import { FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';
import _ from 'lodash';

export function findDuplicateObjectsByProperty<T>(
	arr: Record<string, T>[],
	key: string,
): T[] {
	const groupedByProperty = _.groupBy(arr, key);
	const duplicates = _.filter(groupedByProperty, (items) => items.length > 1);
	return _.map(duplicates, (item) => item[0][key]);
}

export function duplicatesInFormArray(key: string): ValidatorFn {
	return (control: FormArray): ValidationErrors | null => {
		const controls = control?.controls;
		if (!controls.length) {
			return null;
		}

		for (const control of controls) {
			control.get(key).setErrors(null);
		}

		const arrayOfDuplicates = findDuplicateObjectsByProperty(
			control.value,
			key,
		);

		if (!arrayOfDuplicates.length) {
			return null;
		}

		for (const control of controls) {
			const currentControl = control.get(key);
			if (arrayOfDuplicates.includes(currentControl?.value)) {
				currentControl.setErrors({
					duplicatesInFormArray: { value: `${key.toLowerCase()}s` },
				});
			}
		}
	};
}
